import request from '@/utils/request'

// request.get은 falsy body(false, '')를 'empty'로 reject하므로 flag OFF(false) 응답도 에러로 떨어진다.
// flag 조회는 실패해도 화면을 막으면 안 되므로 catch에서 기본값을 반환한다(fail-safe).
export const getFeatureFlag = (key: string) => request.get<boolean>('/v1/feature', { key }).catch(() => false)

export const getFeatureFlagBoolean = (key: string, objectKey: string) =>
  request.get<boolean>('/v1/feature/boolean', { key, objectKey }).catch(() => false)

export const getFeatureFlagString = (key: string, objectKey: string) =>
  request.get<string>('/v1/feature/string', { key, objectKey }).catch(() => '')

export const getFeatureFlagValues = (key: string) => request.get<string[]>('/v1/feature/values', { key }).catch<string[]>(() => [])

// object 타입 flag 중 값이 true 인 필드명 목록. BE 조회 실패 시에도 [] 를 준다.
// config: 로그인 콜백처럼 인터셉터 재인증을 건너뛰어야 하는 호출부가 skipOktaReauth 를 넘긴다.
export const getFeatureFlagKeys = (key: string, config?: Parameters<typeof request.get>[2]) =>
  request.get<string[]>('/v1/feature/keys', { key }, config).catch<string[]>(() => [])
